import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import {
  Pool,
  PoolAdditionalData,
} from '../../../../../../../../apis/pool.api';
import { IProduct } from '../../../../../IProduct';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P00030 } from '../../../../P00030';
import { P00032 } from '../../../../P00032';
import { P0003600EnSavoirPlusComponent } from '../../../../P0003600/Filtration/enSavoirPlus/p0003600-en-savoir-plus/p0003600-en-savoir-plus.component';
import { FunctionParametersSettingsClockScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-settings-clock-screen/function-parameters-settings-clock-screen.component';
import { FunctionParametersSettingClockWeekScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-setting-clock-week-screen/function-parameters-setting-clock-week-screen.component';
import { HeaderConfigurationComponent } from '../../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { IonButton, IonContent } from '@ionic/angular/standalone';
import {
  LabelConfigurationComponent,
  LabelConfigurationWarningMode,
} from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';
import { LargedLinkComponent } from '../../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { MinuterieLabelComponent } from '../../../../../../../../components/ecosystems/minuterie-label/minuterie-label.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TwoChoicesControlComponent } from '../../../../../../../../components/ecosystems/two-choices-control/two-choices-control.component';
import { P0003605ConsigneRegulationRxEnum } from '../../../../P0003605/Enum/P0003605ConsigneRegulationRx';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { P0003607ESPInstallationClComponent } from '../../../EnSavoirPlus/p0003607-espinstallation-cl/p0003607-espinstallation-cl.component';
import { P0003607HysteresisValues } from '../../../Enum/P0003607HysteresisValues';
import { SwitchConfigurationComponent } from '../../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { InformationTitleComponent } from '../../../../../../../../components/ecosystems/information-title/information-title.component';
import { FunctionEnSavoirPlusModalComponent } from '../../../../../../../../components/ecosystems/function-en-savoir-plus-modal/function-en-savoir-plus-modal.component';
import { P0003607TauxAbaissement } from '../../../Enum/P0003607TauxAbaissement';

@Component({
  selector: 'app-p0003607-electrolyseur-mise-en-oeuvre-desinfection',
  templateUrl:
    './p0003607-electrolyseur-mise-en-oeuvre-desinfection.component.html',
  styleUrls: [
    './p0003607-electrolyseur-mise-en-oeuvre-desinfection.component.scss',
  ],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    LabelConfigurationComponent,
    LabelDescriptionComponent,
    LargedLinkComponent,
    MinuterieLabelComponent,
    TranslatePipe,
    TwoChoicesControlComponent,
    SwitchConfigurationComponent,
    InformationTitleComponent,
  ],
})
export class P0003607ElectrolyseurMiseEnOeuvreDesinfectionComponent
  implements OnInit
{
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private slideModalService: SlideModalController =
    inject(SlideModalController);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  @Input() pool: Pool | null = null;

  constructor() {
    this.P0003607ESPInstallationClModal =
      this.P0003607ESPInstallationClModal.bind(this);
    this.openEnSavoirPlus = this.openEnSavoirPlus.bind(this);
  }

  hasProduitP00032() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00032()) ?? 0;
  }

  async P0003607ESPInstallationClModal() {
    const modal = await this.slideModalService.create({
      component: P0003607ESPInstallationClComponent,
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  async openEnSavoirPlus() {
    const modal = await this.slideModalService.create({
      component: FunctionEnSavoirPlusModalComponent,
      componentProps: {
        description: 'P0003607.programmation.ensavoirplus',
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  async goToFunctionParametersSettingsClockScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingsClockScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('esPHorlogeJour'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.ElectrolyseurStandard_Parametrage,
        'esPHorlogeJour',
        hj,
        null,
      );
    }
  }

  async goToFunctionParametersSettingClockWeekScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingClockWeekScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('esPHorlogeSemaine'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.ElectrolyseurStandard_Parametrage2,
        'esPHorlogeSemaine',
        hj,
        null,
      );
    }
  }

  getProductDeviceTableFromPool() {
    const pool = this.edroNetworkManager.getPoolContext().pool!;
    const master = getPoolMasterClass(pool);
    return master!.getProductDeviceTableFromPool(pool!).firmwareVersion < 6
      ? LabelConfigurationWarningMode.NEED_UPDATE
      : master!.getProductDeviceTableFromPool(pool!).firmwareVersion == 6
        ? LabelConfigurationWarningMode.NEW
        : LabelConfigurationWarningMode.NONE;
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P0003605ConsigneRegulationRxEnum =
    P0003605ConsigneRegulationRxEnum;
  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P0003607HysteresisValues = P0003607HysteresisValues;
  protected readonly P0003607TauxAbaissement = P0003607TauxAbaissement;
}
